// extracted by mini-css-extract-plugin
export default {"roleContainer":"RoleDetail_roleContainer__dbR-D"};